module.exports = __webpack_public_path__ + "static/img/blekey2.48c589a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/blekey/key2/blekey2.jpg
// module id = Ks33
// module chunks = 0